import { useState, useEffect, React, useRef, useMemo } from 'react'
import { Draggable } from "react-beautiful-dnd";
import {
  MenuItem, Menu, Button, List, Typography, ListItemIcon, TextField, Box, ListItem, ListItemText, ListItemSecondaryAction, IconButton, Grid, FormControl, Stack, DialogActions, DialogContent,
  ClickAwayListener, InputLabel, OutlinedInput, Checkbox, Autocomplete
} from '@mui/material'
import Select from '@mui/material/Select';
import { getMeasuresList, updateMeasure } from '../../config/services/measures';
import DeleteIcon from '@mui/icons-material/Delete'
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import hashFill from '@iconify/icons-eva/hash-fill';
import { Icon } from '@iconify/react';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { makeStyles } from '@mui/styles';
import { addVersion } from '../../config/services/config';
import toast from 'react-hot-toast';
import { ReactComponent as AngleDownIcon } from '../../assets/icons/icon-angle-down.svg';
import { ReactComponent as MoreIcon } from "../../assets/icons/icon-more.svg";
import { MeasureListContext, useMeasureListContext } from "../../contexts/MeasureListContext";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Popup from '../../components/Popup';
import _, { set } from 'lodash';


const useStyles = makeStyles((theme) => ({
  fieldBtn: {
    position: 'absolute',
    right: '5px',
    bottom: '3px',
    cursor: 'pointer',
  },
}));

const style = {

  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 700,
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  boxShadow: '0px 0px 4px #0000001A',
  p: 4,
  borderRadius: '4px',
};


const ListItemCustom = ({ itemObject, index, reportDetails, updateReportDetails, setPivotConfig, pivotConfig, colId }) => {

  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null);
  const [formatAnchorEl, setFormatAnchorEl] = useState(null);
  const [searchMeasure, setSearchMeasure] = useState('')
  const [measureList, setMeasureList] = useState({ measures: [], dimensions: [] })
  const [currentMeasure, setCurrentMeasure] = useState({})
  // const [currentType, setCurrentType] = useState('')
  const currentTypeRef = useRef();
  const [selectedMeasure, setSelectedMeasure] = useState('')
  const [dateAnchorEl, setDateAnchorEl] = useState(null)
  const [dateSelectAnchorEl, setDateSelectAnchorEl] = useState(null)
  const [formatAnchorMenuEl, setFormatAnchorMenuEl] = useState(null)
  const [concatPopUp, setConcatPopUp] = useState(false)
  const [truncatePopUp, setTruncatePopUp] = useState(false)
  const [concatItem, setConcatItem] = useState({})
  const { measureListByDataset, fetchMeasureListByDataset } = useMeasureListContext();
  const filteredMeasureList = useMemo(() => {
    if (searchMeasure === '') return measureList;
    if (currentTypeRef.current === 'value') {
      // measures
      const _measure = measureList?.measure?.filter((measure) => fuzzySearch(measure?.displayName || measure?.name, searchMeasure)).sort();
      return { ...measureList, measure: _measure }
    } 
    // dimensions
    const _dimensions = measureList?.dimensions?.filter((dimension) => fuzzySearch(dimension?.displayName || dimension?.name, searchMeasure)).sort();
    return { ...measureList, dimensions: _dimensions }
  }, [searchMeasure, measureList]);


  const handleSearchMeasure = (e) => {
    setSearchMeasure(e.target.value);
  }

  function fuzzySearch(text, query) {
    const pattern = query
      .split('')
      .map((char) => `(?=.*${char})`)
      .join('');

    const regex = new RegExp(pattern, 'i');

    return text.match(regex);
  };

  async function fetchMeasureList() {
    const datasetId = typeof reportDetails?.reportDetails?.dataSetId === 'object' ? reportDetails?.reportDetails?.dataSetId?._id : reportDetails?.reportDetails?.dataSetId;

    const measures = measureListByDataset[datasetId] || await fetchMeasureListByDataset(datasetId);
    const measuresList = await measures?.reduce((acc, item) => {
      if (item?.dataSetType === 'MEASURE') acc.measure.push(item);
      else acc.dimensions.push(item);
      return acc
    }, { measure: [], dimensions: [] })
    setMeasureList(measuresList);
  }

  useEffect(() => { fetchMeasureList() }, []);


  const handleClick = (event, measureOrDimention, type) => {
    event.stopPropagation()
    if (measureOrDimention.text === 'measures') return
    if (type === 'value') {
      //measure
      // setCurrentType('value')
      currentTypeRef.current = 'value';
    } else {
      //dimention
      // setCurrentType('dimensions');
      currentTypeRef.current = 'dimensions';
    }
    setAnchorEl(event.currentTarget);
    setCurrentMeasure(measureOrDimention)
  };

  const handleFormatClose = () => {
    setFormatAnchorEl(null);
    setFormatAnchorMenuEl(null)
  };

  const handleDateClose = () => {
    setDateAnchorEl(null);
  }

  const handleDateSelectClose = () => {
    setDateSelectAnchorEl(null)
  }
  const handleDateSelectMenu = (e) => {
    e.stopPropagation()
    setDateSelectAnchorEl(e.currentTarget)
  }

  const handleDateFormatSelect = async (e) => {
    e.stopPropagation();
    const selectedFormat = e?.target?.attributes?.value?.value;
    if (selectedFormat) {
      for (let dim of reportDetails?.reportDetails?.dimensions) {
        if (dim?.fieldId === selectedMeasure?._id) {
          dim.dateFormat = selectedFormat
          break;
        }
      }
      updateReportDetails({ reportDetails: reportDetails.reportDetails })
      handleDateSelectClose()
      handleDateClose()
    }
  }


  const handleClose = () => {
    setAnchorEl(null);
  };


  const clickMeasureListHandler = (e, measure, item) => {
    e.stopPropagation();
    let dataExit = false;

    if (measure.dataSetType === "MEASURE") {
      for (let i = 0; i < reportDetails?.reportDetails?.measures.length; i++) {
        if (reportDetails?.reportDetails?.measures[i]?.fieldId === measure?._id) {
          dataExit = true;
        }
      }
      if (dataExit) {
        reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures.filter(item => item?.fieldId !== measure?._id)
        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name)
        reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(item => item?.text !== reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name)
      }
      else {

        let name = currentMeasure.text ? currentMeasure.text : currentMeasure?.fieldName
        reportDetails?.reportDetails?.measures.find((itm, index) => {
          if (itm?.fieldName === name) {
            reportDetails?.reportDetails?.measures.splice(index, 1, {
              fieldName: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
              displayName: measure?.displayName,
              fieldId: measure?._id
            })
          }
        })

        reportDetails?.reportDetails?.pivotConfig?.value?.list.find((itm, index) => {
          if (itm?.text === name) {
            reportDetails?.reportDetails?.pivotConfig?.value?.list.splice(index, 1, {
              text: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + (measure?.name),
              id: measure?._id,
              type: "measures",
              displayName: measure?.displayName,
              visibleInFieldwell: false
            })
          }
        })

        reportDetails?.reportDetails?.orderBy.find((ele, index) => {
          if (ele?.content?.key === name) {

            if (measure?.type === 'number') {
              reportDetails?.reportDetails?.orderBy.splice(index, 1, {
                id: measure?._id,
                content: {
                  key: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
                  displayName: measure?.displayName,
                  order: 'desc'
                }
              })
            }
            else if (measure?.type === 'string') {
              reportDetails?.reportDetails?.orderBy.splice(index, 1, {
                id: measure?._id,
                content: {
                  key: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
                  displayName: measure?.displayName,
                  order: 'asc'
                }
              })
            }
            else {
              reportDetails?.reportDetails?.orderBy.splice(index, 1, {
                id: measure?._id,
                content: {
                  key: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
                  displayName: measure?.displayName,
                  order: 'desc'
                }
              })
            }
          }
        })
      }
    }
    else if (item?.text !== 'measures') {
      for (let i = 0; i < reportDetails?.reportDetails?.dimensions.length; i++) {
        if (reportDetails?.reportDetails?.dimensions[i]?.fieldId === measure?._id) {
          dataExit = true;
        }
      }
      if (dataExit) {
        reportDetails.reportDetails.dimensions = reportDetails?.reportDetails.dimensions.filter(item => item?.fieldId !== measure?._id)

        reportDetails.reportDetails.pivotConfig.xAxis.list = reportDetails?.reportDetails?.pivotConfig?.xAxis?.list.filter(item => item.text !== reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name)
        reportDetails.reportDetails.pivotConfig.value.list = reportDetails?.reportDetails?.pivotConfig?.value?.list.filter(item => item.text !== reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name)

        reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name)

      }
      else {

        reportDetails?.reportDetails?.pivotConfig?.xAxis?.list.find((itm, index) => {
          if (itm.text === item?.text) {
            reportDetails?.reportDetails?.pivotConfig?.xAxis?.list.splice(index, 1, {
              text: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + (measure?.name),
              id: measure?._id,
              displayName: measure?.displayName,
              type: "dimensions"
            })
          }
        })

        reportDetails?.reportDetails?.pivotConfig?.value?.list.find((itm, index) => {
          if (itm.text === item?.text) {
            reportDetails?.reportDetails?.pivotConfig?.value?.list.splice(index, 1, {
              text: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + (measure?.name),
              id: measure?._id,
              displayName: measure?.displayName,
              type: "measures"
            })
          }
        })

        reportDetails?.reportDetails?.orderBy.find((ele, index) => {
          if (ele?.content?.key === item?.text) {

            if (measure?.type === 'number') {
              reportDetails?.reportDetails?.orderBy.splice(index, 1, {
                id: measure?._id,
                content: {
                  key: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
                  displayName: measure?.displayName,
                  order: 'desc'
                }
              })
            }
            else if (measure?.type === 'string') {
              reportDetails?.reportDetails?.orderBy.splice(index, 1, {
                id: measure?._id,
                content: {
                  key: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
                  displayName: measure?.displayName,
                  order: 'asc'
                }
              })
            }
            else {
              reportDetails?.reportDetails?.orderBy.splice(index, 1, {
                id: measure?._id,
                content: {
                  key: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
                  displayName: measure?.displayName,
                  order: 'desc'
                }
              })
            }
          }
        })

        reportDetails.reportDetails.dimensions = reportDetails?.reportDetails?.dimensions.filter(i => i?.fieldName !== item?.text)

        reportDetails?.reportDetails?.dimensions.push({
          fieldName: reportDetails?.reportDetails?.dataSetId?.dataSetName + "." + measure?.name,
          fieldId: measure?._id,
          displayName: measure?.displayName
        });

      }
    }
    updateReportDetails({ reportDetails: reportDetails?.reportDetails });
    handleClose();
  }

  const setClassNameMeasureReport = (measure) => {
    let findInMeasures = reportDetails?.reportDetails?.measures.find(item => item.fieldId === measure._id)
    let findInDimensions = reportDetails?.reportDetails?.dimensions.find(item => item.fieldId === measure._id)

    if (findInMeasures || findInDimensions)
      return "visualize_list_text"
    return "visualize_list_text_non";
  }


  const removeSelectedFields = (measure) => {

    if (measure?.text === 'measures' && currentMeasure && Object.keys(currentMeasure).length) {
      let measure = {
        text: currentMeasure?.fieldName,
      }

      reportDetails.reportDetails.dimensions = reportDetails?.reportDetails.dimensions.filter(item => item?.fieldName !== measure?.text)

      reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures.filter(item => item?.fieldName !== measure?.text)

      reportDetails.reportDetails.pivotConfig['xAxis'].list = reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.pivotConfig['lines'].list = reportDetails?.reportDetails?.pivotConfig['lines']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.pivotConfig['group'].list = reportDetails?.reportDetails?.pivotConfig['group']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== measure?.text)

      reportDetails.reportDetails.settings.groupBySettings = reportDetails?.reportDetails?.settings?.groupBySettings?.map(obj => {
        obj.concatWith = obj?.concatWith?.filter(element => element !== measure?.text);
        return obj;
      });



    }

    else {

      reportDetails.reportDetails.dimensions = reportDetails?.reportDetails?.dimensions.filter(item => item?.fieldName !== measure?.text)

      reportDetails.reportDetails.measures = reportDetails?.reportDetails?.measures.filter(item => item?.fieldName !== measure?.text)

      reportDetails.reportDetails.pivotConfig['xAxis'].list = reportDetails?.reportDetails?.pivotConfig['xAxis']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.pivotConfig['value'].list = reportDetails?.reportDetails?.pivotConfig['value']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.pivotConfig['lines'].list = reportDetails?.reportDetails?.pivotConfig['lines']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.pivotConfig['group'].list = reportDetails?.reportDetails?.pivotConfig['group']?.list.filter(ele => ele?.text !== measure?.text)

      reportDetails.reportDetails.orderBy = reportDetails?.reportDetails?.orderBy.filter(ele => ele?.content?.key !== measure?.text)

      reportDetails.reportDetails.settings.groupBySettings = reportDetails?.reportDetails?.settings?.groupBySettings?.map(obj => {
        obj.concatWith = obj?.concatWith?.filter(element => element !== measure?.text);
        return obj;
      });


    }
    updateReportDetails({ reportDetails: reportDetails?.reportDetails })
    handleClose()
  }


  const handleFormatMenu = (event, measure) => {
    event.stopPropagation()
    setFormatAnchorMenuEl(event.currentTarget)
    setSelectedMeasure(measure)
  }

  const handleFormatMenuSelect = (event) => {
    event.stopPropagation()
    setFormatAnchorEl(event.currentTarget)

  }
  const handleDateMenu = (e, measure) => {
    e.stopPropagation()
    setDateAnchorEl(e.currentTarget)
    setSelectedMeasure(measure)
  }

  const handleFormatSelect = async (e) => {
    e.stopPropagation()
    const selectedFormat = e?.target?.attributes?.value?.value;
    if (selectedFormat) {
      let params = { measureId: selectedMeasure?._id, format: selectedFormat }
      const res = await updateMeasure(params)
      await addVersion(new Date().getTime().toString())
      handleFormatClose()
      toast.success(res.message)
    }
  }

  const getItemDisplayName = (item) => {
    const itemText = item?.text;
    const measures = reportDetails?.reportDetails?.measures;
    const dimensions = reportDetails?.reportDetails?.dimensions;
    let displayName;
    for (let meas of measures) {
      if (meas?.fieldName === itemText) {
        displayName = meas?.displayName;
        break;
      }
    }
    if (!displayName) {
      for (let dim of dimensions) {
        if (dim?.fieldName === itemText) {
          displayName = dim?.displayName;
          break;
        }
      }
    }

    return displayName ? displayName : itemText?.split('.')[1]
  }


  const renderItems = () => {
    if (itemObject?.visibleInFieldwell === false) {
      return
    }

    if (itemObject.text === 'measures') {
      if (reportDetails?.reportDetails?.measures?.length) {
        return reportDetails?.reportDetails?.measures?.map((meas, i) => (
          <div key={i} className="pivotMeasureText border-0" onClick={e => handleClick(e, meas, 'value')}>
            <ListItemText className="color-text-main" primary={meas?.displayName || meas?.fieldName.split('.')[1]} />
            <Button className='report_field_wells_end_icon' endIcon={<AngleDownIcon />} />
          </div>))

      }
      else {
        return <ListItemText className="color-text-main" primary="measures" />
      }

    }
    else {
      return <ListItemText primary={getItemDisplayName(itemObject)} />
    }
  }

  const handleHideReportColumn = (value) => {
    if (currentTypeRef.current === 'value') {
      const reportObj = reportDetails?.reportDetails?.measures.find(meas => meas?.fieldName.split('.')[1] === currentMeasure?.fieldName.split('.')[1]);
      reportObj.isHidden = value
    }
    if (currentTypeRef.current === 'dimensions') {
      const reportObj = reportDetails?.reportDetails?.dimensions.find(dim => dim?.fieldName.split('.')[1] === currentMeasure?.text.split('.')[1])
      reportObj.isHidden = value
    }
    setAnchorEl(null)
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const renderHideColumnMenu = () => {
    if (currentMeasure) {
      if (currentTypeRef.current === 'value' && reportDetails?.reportDetails?.measures.length) {
        const fieldObj = reportDetails?.reportDetails?.measures?.find(meas => meas?.fieldName?.split('.')[1] === currentMeasure?.fieldName?.split('.')[1])
        if (fieldObj) {
          if (fieldObj?.isHidden) {
            return (<Button startIcon={<VisibilityOffIcon />} variant="outlined" className="field_wells_ibtn" onClick={(e) => handleHideReportColumn(false)}>
              Unhide Column
            </Button>
            )
          }
          else {
            return (<Button startIcon={<VisibilityIcon />} variant="outlined" className="field_wells_ibtn" onClick={(e) => handleHideReportColumn(true)}>
              Hide Column
            </Button>
            )
          }
        }
      }
      else if ((currentMeasure?.type === 'dimensions' || currentTypeRef.current == 'dimensions') && reportDetails?.reportDetails?.dimensions.length) {
        const fieldObj = reportDetails?.reportDetails?.dimensions?.find(dim => dim?.fieldName?.split('.')[1] == currentMeasure?.text?.split('.')[1])
        if (fieldObj) {
          if (fieldObj?.isHidden) {
            return (
              <Button startIcon={<VisibilityOffIcon />} variant="outlined" className="field_wells_ibtn" onClick={(e) => handleHideReportColumn(false)}>
                Unhide Column
              </Button>

            )
          }
          else {
            return (<Button startIcon={<VisibilityIcon />} variant="outlined" className="field_wells_ibtn" onClick={(e) => handleHideReportColumn(true)}>
              Hide Column
            </Button>

            )
          }
        }
      }
    }
  }


  const downloadSelectedFields = (obj) => {
    let value = currentMeasure.text ? currentMeasure.text : currentMeasure?.fieldName
    const index = reportDetails.reportDetails.settings.downloadable?.indexOf(value);
    if (index !== -1) {
      reportDetails.reportDetails.settings.downloadable?.splice(index, 1);
    } else {
      reportDetails.reportDetails.settings.downloadable?.push(value);
    }
    if (typeof reportDetails.reportDetails.settings.downloadable[0] === 'object' && Object.keys(reportDetails.reportDetails.settings.downloadable[0]).length === 0)
      reportDetails.reportDetails.settings.downloadable?.shift();
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const concatSelectedFields = (value) => {
    setConcatItem(currentMeasure)
    setConcatPopUp(true)
  }

  const truncateSelectedFileds = (value) => {
    setConcatItem(currentMeasure)
    setTruncatePopUp(true)
  }

  return (
    <>
      <Draggable draggableId={itemObject.id} key={itemObject.id} index={index}>
        {(provided) => (
          <div
            onClick={e => handleClick(e, itemObject, 'measures')}
            className={`order_btn` + (colId === 'value' && itemObject.text !== 'measures') ? 'pivotMeasureDropdown' : (itemObject.text === 'measures' && colId === 'value') ? 'pivotValueDropdown' : (itemObject.text === 'measures' && colId === 'xAxis') ? 'pivotXDropdown' : 'pivotDimensionDropdown'}>
            <ListItem
              className='fieldAxisOrderContent'
              key={itemObject.id}
              role={undefined}
              dense
              button
              ContainerComponent="li"
              ContainerProps={{ ref: provided.innerRef }}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              sx={{ py: 1 }}
            >
              <Box className="width-100 cur_grab">
                {renderItems() ?? null}
              </Box>

              {itemObject.text !== 'measures' ? <Button
                className="report_field_wells_end_icon"
                endIcon={<AngleDownIcon />} /> : null}


              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="comments"
                  question-uid={itemObject.id}
                >
                </IconButton>
              </ListItemSecondaryAction>

            </ListItem>
          </div>

        )}

      </Draggable>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="pivotMenu"
      >

        <Grid container display="flex" justifyContent="flex-start" className="re-fieldwells-pop-content">
          <Grid className="text-center" item xs={6} sm={6} lg={6}>
            {
              renderHideColumnMenu()
            }
          </Grid>
          <Grid className="text-center" item xs={6} sm={6} lg={6} >
            <Button startIcon={<DeleteIcon />} variant='outlined' className='field_wells_ibtn'
              onClick={e => removeSelectedFields(itemObject)}>Remove</Button>
          </Grid>


          <Grid className="text-center" item xs={6} sm={6} lg={6} >
            <Button variant='outlined' className='field_wells_ibtn'
              onClick={e => concatSelectedFields(itemObject)}>Concatenate</Button>
          </Grid>

          <Grid className="text-center" item xs={6} sm={6} lg={6} >
              <Button variant='outlined' className='field_wells_ibtn'
              onClick={e => downloadSelectedFields(itemObject)}>Download</Button>
          </Grid>

          <Grid className="text-center" item xs={6} sm={6} lg={6} >
              <Button variant='outlined' className='field_wells_ibtn'
              onClick={e => truncateSelectedFileds(itemObject)} >Truncate</Button>
            </Grid>
        </Grid>
        {colId === 'Lines' ? null :
          <div className="re-fieldwells-pop-fields">
            <Box width="100%" height="100%" mt={2}>
              <TextField className="cm_rprt_setting_content" type="search" size="small" label="Fields list" placeholder="Search fields.." onChange={handleSearchMeasure} />
            </Box>
            <div className="field_list " >
              <List component="nav" aria-label="main mailbox folders" className="field_list">
                {(currentTypeRef.current === 'value' ? filteredMeasureList?.measure : filteredMeasureList?.dimensions)?.map((measure, i) => (
                  !measure?.joinHiddenField &&
                  <ListItem
                      key={`${currentTypeRef.current}-${measure.name}`}
                    className={setClassNameMeasureReport(measure)}
                    onClick={(e) => clickMeasureListHandler(e, measure, itemObject)}
                    sx={{ py: 1 }}
                  >
                    <ListItemIcon>
                      {measure.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon" /> : measure.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : measure.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                    </ListItemIcon>
                    <Typography variant="body2"> {measure?.displayName || measure?.name} </Typography>

                    {measure.calculatedField &&
                      <Button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        className={classes.fieldBtn + " no-hover"}
                        onClick={(e) => handleFormatMenu(e, measure)}
                      >
                        <MoreIcon />
                      </Button>
                    }

                    {measure?.type === 'time' &&
                      <Button
                        aria-controls="date-menu"
                        aria-haspopup="true"
                        className={classes.fieldBtn + " no-hover field_list_icon"}
                        onClick={(e) => handleDateMenu(e, measure)}
                      >
                        <MoreIcon />
                      </Button>
                    }
                  </ListItem>
                ))}

                <Menu
                  id="simple-menu"
                  anchorEl={formatAnchorMenuEl}
                  keepMounted
                  open={Boolean(formatAnchorMenuEl)}
                  onClose={handleClose}
                  className={classes.fieldMenu}
                >
                  <MenuItem>Change Format<Button className="no-hover" aria-controls="format-menu" aria-haspopup="true" onClick={e => handleFormatMenuSelect(e)} style={{ color: 'gray' }} endIcon={<AngleDownIcon />}>

                  </Button>
                    <Menu
                      id="format-menu"
                      anchorEl={formatAnchorEl}
                      keepMounted
                      open={Boolean(formatAnchorEl)}
                      onClose={handleFormatClose}
                      onClick={handleFormatSelect}
                    >
                      <MenuItem value="number" >Number</MenuItem>
                      <MenuItem value="percent">Percent</MenuItem>
                    </Menu>
                  </MenuItem>
                </Menu>

                <Menu
                  id="date-menu"
                  anchorEl={dateAnchorEl}
                  keepMounted
                  open={Boolean(dateAnchorEl)}
                  onClose={handleDateClose}
                >
                  <MenuItem >Change Format <Button className="no-hover" aria-controls="date-select-menu" aria-haspopup="true" onClick={e => handleDateSelectMenu(e)} style={{ color: 'gray' }} endIcon={<AngleDownIcon />}>
                  </Button>

                    <Menu
                      id="date-select-menu"
                      anchorEl={dateSelectAnchorEl}
                      keepMounted
                      open={Boolean(dateSelectAnchorEl)}
                      onClose={handleDateSelectClose}
                      onClick={handleDateFormatSelect}
                    >
                      <MenuItem value="YYYY-MM-DD">YYYY-MM-DD</MenuItem>
                      <MenuItem value="MM-DD-YYYY">MM-DD-YYYY</MenuItem>
                      <MenuItem value="DD-MM-YYYY">DD-MM-YYYY</MenuItem>
                      <MenuItem value="YYYY-MM-DD hh:mm:ss">YYYY-MM-DD hh:mm:ss</MenuItem>
                      <MenuItem value="MMMM-DD-YYYY">MMMM-DD-YYYY</MenuItem>
                      <MenuItem value="DD-MMM-YY">DD-MMM-YY</MenuItem>
                    </Menu>
                  </MenuItem>
                </Menu>

              </List>
            </div>

            {/* <Autocomplete
              id='fieldwells-autocomplete'
              options={currentType === 'value' ? measureList?.measures : measureList?.dimensions}
              getOptionLabel={Option => Option?.displayName || Option?.name}
              renderOption={RenderOption}
              style={{ width: '100%' }}
              onChange={(e, value) => clickMeasureListHandler(e, value, itemObject)}
              renderInput={(params) => <TextField {...params} label="Fields list" variant="outlined" />}
            /> */}
          </div>}
      </Menu>

      {concatPopUp ? <ConcatenatePopUp reportDetails={reportDetails} concatItem={concatItem} setConcatPopUp={setConcatPopUp} updateReportDetails={updateReportDetails} /> : null}

      {truncatePopUp ? <TruncatePopUp reportDetails={reportDetails} concatItem={concatItem} setTruncatePopUp={setTruncatePopUp} updateReportDetails={updateReportDetails} /> : null}

    </>

  );
};


const ConcatenatePopUp = (props) => {

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [seletedField, setSelectedField] = useState([]);
  const [concatBy, setConcatBy] = useState('')
  const [openPopup, setOpenPopup] = useState(true)

  let { reportDetails, concatItem, setConcatPopUp, updateReportDetails } = props


  const filteredFields = useMemo(() => {
    const fields = [...reportDetails?.reportDetails?.dimensions, ...reportDetails?.reportDetails?.measures];
    return fields.filter(obj => obj.fieldName != (concatItem.fieldName ? concatItem.fieldName : concatItem.text));
  }, [reportDetails]);

  const handleConcatWith = (e) => {
    const { value } = e?.target;
    setSelectedField(value)
  }

  const handleConcatBy = (e) => {
    const { value } = e?.target;
    setConcatBy(value)
  }

  const handleCancel = () => {
    setOpenPopup(false)
    setConcatPopUp(false)
    setConcatBy('')
    setSelectedField([])
  }

  const handleSave = () => {
    let cloneDetails = _.cloneDeep(reportDetails)
    if (concatBy.length === 0) {
      toast.error('Operator is required');
      return;
    }
    if (seletedField.length === 0) {
      toast.error('Concat With Field is required');
      return;
    }
    cloneDetails.reportDetails.settings.groupBySettings = [...cloneDetails.reportDetails.settings.groupBySettings, {
      concatAt: concatItem?.fieldName ? concatItem?.fieldName : concatItem?.text,
      concatBy: concatBy,
      concatWith: seletedField
    }]
    updateReportDetails({ reportDetails: cloneDetails.reportDetails });
    setOpenPopup(false)
    setConcatPopUp(false)
  }

  return (
    <>
      <Popup
        title={'Concat Field'}
        openPopup={openPopup}
        setOpenPopup={openPopup}
      >
        <DialogContent className="custom-modal-content">
          <Stack>
            <FormControl fullWidth>
              <InputLabel id="demo-multiple-checkbox-label">Fields</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={seletedField}
                onChange={handleConcatWith}
                // input={<OutlinedInput label="Fields" />}
                renderValue={(selected) => selected?.join(', ')}
                MenuProps={MenuProps}
              >
                {filteredFields.map((item) => (
                  <MenuItem key={item?.fieldId} value={item?.text ? item?.text : item?.fieldName}>
                    <Checkbox checked={seletedField?.indexOf(item?.text ? item?.text : item?.fieldName) > -1} />
                    <ListItemText primary={item?.displayName ? item?.displayName : item?.fieldName?.split('.')[1]} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <label>Concat By</label>
              <TextField className="select_min_width" placeholder="Operator" onChange={e => handleConcatBy(e)} />
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions className="btn-group">
          <Button color="error" className="report_form_ui_btn cancel mr-2" onClick={handleCancel}> Cancel </Button>
          <Button color="primary" className="report_form_ui_btn submit" autoFocus onClick={handleSave}> Save </Button>
        </DialogActions>
      </Popup>
    </>
  )
}

const TruncatePopUp = (props) => {

  const [openPopup, setOpenPopup] = useState(true)
  const [splitBy, setSplitBy] = useState('');
  const [wordLimit, setWordLimit] = useState('')

  let { reportDetails, concatItem, setTruncatePopUp, updateReportDetails } = props

  const handleSplitBy = (e) => {
    const { value } = e?.target;
    setSplitBy(value)
  }

  const handleWordLimit = (e) => {
    const { value } = e?.target;
    setWordLimit(value)
  }

  const handleCancel = () => {
    setOpenPopup(false)
    setTruncatePopUp(false)
    setSplitBy('')
    setWordLimit('')
  }

  const handleSave = () => {
    let cloneDetails = _.cloneDeep(reportDetails)
    if (splitBy.length === 0) {
      toast.error('Operator is required');
      return;
    }
    if (wordLimit.length === 0) {
      toast.error('Word Limit is required');
      return;
    }

    let truncatedSettings = []
    if (cloneDetails?.reportDetails?.settings?.truncateSettings) {
      truncatedSettings = [...cloneDetails?.reportDetails?.settings?.truncateSettings]
    }
    cloneDetails.reportDetails.settings.truncateSettings = [...truncatedSettings, {
      truncateAt: concatItem?.fieldName ? concatItem?.fieldName : concatItem?.text,
      splitBy: splitBy,
      wordLimit: wordLimit

    }]
    updateReportDetails({ reportDetails: cloneDetails.reportDetails });
    setOpenPopup(false)
    setTruncatePopUp(false)
  }

  return (
    <>
      <Popup
        title={'Truncate Field'}
        openPopup={openPopup}
        setOpenPopup={openPopup}
      >
        <DialogContent className="custom-modal-content">
          <Stack>
            <FormControl fullWidth>
              <label>Split By</label>
              <TextField className="select_min_width" placeholder="Split By" onChange={e => handleSplitBy(e)} />
            </FormControl>

            <FormControl fullWidth>
              <label>Word Limit</label>
              <TextField className="select_min_width" placeholder="Word limit" onChange={e => handleWordLimit(e)} />
            </FormControl>
          </Stack>
        </DialogContent>
        <DialogActions className="btn-group">
          <Button color="error" className="report_form_ui_btn cancel mr-2" onClick={handleCancel}> Cancel </Button>
          <Button color="primary" className="report_form_ui_btn submit" autoFocus onClick={handleSave}> Save </Button>
        </DialogActions>
      </Popup>
    </>
  )
}

export { ListItemCustom, ConcatenatePopUp, TruncatePopUp }
